(function (window) {
  'use strict';

  const categoriesOpenClass = 'js-filters-categories-open';
  const categoryOpenClass = 'js-filters-category-open';
  const preventTransitionsClass = 'js-filters-prevent-transitions';
  const selectedFrameStyle = 'js-filters-selected-frame-style';
  const activeFiltersClass = 'js-filters-active';
  const filtersCategoriesWrapper = document.querySelector('.filters__categories-wrapper');
  let filters = null;
  let originalFilters = null;
  let selectedFilters = null;
  let resizeTimeout;

  function isMobile() {
    return (window.innerWidth < 680);
  }

  function handlePageResize(e) {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        resizeTimeout = null;
        handleFilterCategoriesEventListener();
      }, 100);
    }
  }

  // It is bypassing the isMobile check.
  function handleFilterCategoriesEventListener() {
    if (filtersCategoriesWrapper && isMobile()) {
      filtersCategoriesWrapper.addEventListener('keydown', handleFilterCategoriesKeyDown);
    } else if (filtersCategoriesWrapper) {
      filtersCategoriesWrapper.removeEventListener('keydown', handleFilterCategoriesKeyDown);
    }
  }

  // This function traps the user keyboard events into the filter__categories-wrapper simulating a dialog box.
  function handleFilterCategoriesKeyDown(e) {
    handleModalKeydown(e, closeFiltersCategories);
  }

  function startFiltersActAsModals() {
    const filtersCategoriesWrapper = filters.querySelector('.filters__categories-wrapper');
    filtersCategoriesWrapper.setAttribute('role','dialog');
    filtersCategoriesWrapper.setAttribute('aria-hidden', false);
    filtersCategoriesWrapper.querySelector('.filters__close-button').focus();
  }

  function stopFiltersActAsModals() {
    const filtersCategoriesWrapper = filters.querySelector('.filters__categories-wrapper');
    filtersCategoriesWrapper.removeAttribute('role');
    filtersCategoriesWrapper.removeAttribute('aria-hidden');
    filters.querySelector('.filter-controls__button').focus();
  }

  function openFiltersCategories() {
    document.body.classList.add(categoriesOpenClass);

    if (isMobile()) {
      startFiltersActAsModals();
    }
  }

  function closeFiltersCategories(e) {
    const categories = filters.querySelectorAll('.js-filters-category');

    for (let i = 0; i < categories.length; i++) {
      categories[i].classList.remove(categoryOpenClass);
    }

    if (isMobile()) {
      stopFiltersActAsModals()
    }

    document.body.classList.remove(categoriesOpenClass);
  }

  function resetFilters(e) {
    while (selectedFilters.firstChild) {
      selectedFilters.firstChild.click();
    }

    filters.classList.remove(activeFiltersClass);
  }

  function toggleCategoryVisibility(e) {
    const categoryWrapper = e.target.closest('.js-filters-category');
    // Set other elements that might be expanded to false.
    const ariaExpanded = document.querySelector('.filters__category-button[aria-expanded="true"]');
    if (ariaExpanded !== null) {
      ariaExpanded.setAttribute('aria-expanded', false);
    }

    if (!categoryWrapper.classList.contains(categoryOpenClass)) {
      openCategory(categoryWrapper);
      addAriaExpanded(categoryWrapper);
    }
    else {
      closeCategory(categoryWrapper);
      removeAriaExpanded(categoryWrapper);
    }
  }

  function openCategory(categoryWrapperToOpen) {
    const categoryWrappers = filters.querySelectorAll('.js-filters-category');

    for (let i = 0; i < categoryWrappers.length; i++) {
      const categoryWrapper = categoryWrappers[i];

      if (categoryWrapper != categoryWrapperToOpen) {
        closeCategory(categoryWrapper, true);
      }
    }

    categoryWrapperToOpen.classList.add(categoryOpenClass);

    // Wait for the open transition to finish before adding a class that
    // prevents transitions when switching between categories.
    if (!document.body.classList.contains(preventTransitionsClass)) {
      categoryWrapperToOpen.addEventListener('transitionend', handleCategoryOpenTransitionend);
    }
  }

  function closeCategory(categoryWrapperToClose, openingAnotherCategory) {
    openingAnotherCategory = openingAnotherCategory || false;

    categoryWrapperToClose.classList.remove(categoryOpenClass);

    if (!openingAnotherCategory) {
      document.body.classList.remove(preventTransitionsClass);
    }
  }

  function addAriaExpanded(categoryWrapper) {
    // Find the button and add aria-expanded to true.
    categoryWrapper.querySelector('.filters__category-button').setAttribute('aria-expanded', true);
  }

  function removeAriaExpanded(categoryWrapper) {
    // Find the button and set aria-expanded to false.
    categoryWrapper.querySelector('.filters__category-button').setAttribute('aria-expanded', false);
  }

  function handleCategoryOpenTransitionend(e) {
    // All child events bubble up, so ensure this is the one we want to act on.
    if (e.target.classList.contains('js-filters-subcategory-wrapper') && e.propertyName == 'opacity') {
      document.body.classList.add(preventTransitionsClass);

      e.target.closest('.js-filters-category').removeEventListener(e.type, handleCategoryOpenTransitionend);
    }
  }

  function toggleFilter(e) {
    if (e.target.checked) {
      addFilter(e.target);
    }
    else {
      removeFilter(e.target);
    }
  }

  function frameFocusIn(e) {
    e.target.parentNode.classList.add(selectedFrameStyle);
  }

  function frameFocusOut(e) {
    if (e.target.parentNode.classList.contains(selectedFrameStyle)) {
      e.target.parentNode.classList.remove(selectedFrameStyle);
    }
  }

  // Construct the element listed among the selected filters.
  function addFilter(input) {
    const filterId = input.getAttribute('data-id');
    const filterValue = input.getAttribute('data-value');
    const filterToggle = input.getAttribute('data-toggle');
    const selectedFilter = document.createElement('button');
    const selectedFilterIcon = document.querySelector('.js-selected-filter-close-icon svg').cloneNode(true);
    const selectedFilterContent = document.createTextNode(filterValue);
    const spanNode = document.createElement('span');
    window.filters_i18n = window.filters_i18n || {}
    if (!window.filters_i18n.deselectText) {
      window.filters_i18n.deselectText = 'Deselect filter';
    }
    const spanTextNode = document.createTextNode(window.filters_i18n.deselectText + ': ');

    spanNode.appendChild(spanTextNode);
    spanNode.classList.add('u-visually-hidden');
    selectedFilter.appendChild(spanNode);
    selectedFilter.appendChild(selectedFilterIcon);
    selectedFilter.appendChild(selectedFilterContent);
    selectedFilter.classList.add('js-filters-selected-filter');
    selectedFilter.setAttribute('data-id', filterId);
    selectedFilter.addEventListener('click', removeSelectedFilter);

    // See toggleVisibility().
    if (filterToggle) {
      selectedFilter.setAttribute('data-toggle', filterToggle);
      selectedFilter.setAttribute('data-toggled', true);
      selectedFilter.addEventListener('click', toggleVisibility);
    }

    selectedFilters.appendChild(selectedFilter);

    // Toggles visibility of the reset button.
    filters.classList.add(activeFiltersClass);
  }

  function removeSelectedFilter(e) {
    removeFilter(e.target);
  }

  // Remove the element listed among the selected filters, uncheck the original.
  function removeFilter(input) {
    const filterId = input.getAttribute('data-id');
    const originalFilter = originalFilters.querySelector('[data-id="' + filterId + '"]');
    const selectedFilter = selectedFilters.querySelector('[data-id="' + filterId + '"]');

    if (originalFilter.checked) {
      originalFilter.checked = false;
    }

    if (selectedFilter) {
      selectedFilter.remove();
    }

    // Toggles visibility of the reset button.
    if (!selectedFilters.firstChild) {
      filters.classList.remove(activeFiltersClass);
    }
  }

  // When a back/forward button is used, checkbox states are preserved but
  // previous JS execution is not. So if a filter had been selected on a page
  // navigated to via back/forward, it will appear selected in the dropdown but
  // not elsewhere. The checkboxes need to be reset in that situation.
  function resetFilterIfUnselected(input) {
    if (input.checked) {
      // This code is also called when Ajax replaces the filter markup as
      // filters are changed, so we must check if the filter should actually be
      // selected (if it has a corresponding item in the selected list) or not.
      const selectedFilter = filters.querySelector(`.js-filters-selected-filter[data-id="${input.getAttribute('data-id')}"]`);

      if (!selectedFilter) {
        input.checked = false;
      }
    }
  }

  function switchAngle(e) {
    const angleButton = e.target;

    if (angleButton.getAttribute('aria-pressed') !== 'true') {
      const angleButtons = filters.querySelectorAll('.js-filters-angle-button');

      for (let i = 0; i < angleButtons.length; i++) {
        angleButtons[i].setAttribute('aria-pressed', 'false');
      }

      angleButton.setAttribute('aria-pressed', 'true');

      switchCardImageAngles(angleButton.getAttribute('data-id'));
      switchCardImageAltTag(angleButton.getAttribute('data-id'));
    }
  }

  function switchCardImageAngles(newAngleId) {
    const cardImages = document.querySelectorAll('.js-card-image');

    for (let i = 0; i < cardImages.length; i++) {
      const cardImage = cardImages[i];
      const currentVariantId = cardImage.getAttribute('data-variant');
      const newImageAttribute = 'data-' + currentVariantId + '-' + newAngleId;

      cardImage.setAttribute('src', cardImage.getAttribute(newImageAttribute));
      cardImage.setAttribute('data-angle', newAngleId);
    }
  }

  function switchCardImageAltTag(newAngleId) {
    const cardImages = document.querySelectorAll('.js-card-image');

    for (let i = 0; i < cardImages.length; i++) {
      const cardImage = cardImages[i];
      const currentVariantColor = cardImage.getAttribute('data-color');
      const currentVariantStyle = cardImage.getAttribute('data-style');
      const newAlt = currentVariantColor + ' ' + currentVariantStyle + ' ' + newAngleId + ' View';

      cardImage.setAttribute('alt', newAlt);
    }
  }

  // Keeps multiple Prescription controls (needed for different placement at
  // different screen sizes) in sync as either are toggled.
  function togglePrescription(e) {
    const prescriptionControls = filters.querySelectorAll('.js-filters-prescription-control');

    for (let i = 0; i < prescriptionControls.length; i++) {
      prescriptionControls[i].checked = e.target.checked;
    }
  }

  // Handles visibility toggles within the filter interface in situations where
  // the library controls it (secondary landing pages, for example, not PLPs).
  // The code is relatively complex to support all necessary use cases.
  // For this to work, the following attributes must be applied:
  // - data-toggle="category" should be set on the clickable toggle, where
  //   `category` is the group of items this toggle.
  // - data-toggle-exclusive="true" should be set when enabling a toggle should
  //   disable all previously enabled toggles.
  // - data-toggled="true" is set within this code on toggle elements and should
  //   not be set server side unless a toggle is enabled on page load.
  // - data-toggle-item="category multiple" should be set on the items whose
  //   visibility are affected by the toggles, where `category` should match the
  //   data-toggle value that controls it. Can have multiple values, separated
  //   by a space.
  function toggleVisibility(e) {
    const toggle = e.target.closest('[data-toggle]');
    const category = toggle.getAttribute('data-toggle');
    const allToggles = document.querySelectorAll('[data-toggle]');
    const allItems = document.querySelectorAll(`[data-toggle-item]`);
    let currentlyOn = [];

    // Determine what was toggled on before the toggle in question was clicked.
    for (let i = 0; i < allToggles.length; i++) {
      if (allToggles[i].getAttribute('data-toggled')) {
        const currentCategory = allToggles[i].getAttribute('data-toggle');

        currentlyOn.push(currentCategory);
      }
    }

    // Update that information with information about the toggle in question.
    if (!toggle.getAttribute('data-toggled')) {
      // Items with this attribute disable all previously enabled toggles.
      if (toggle.getAttribute('data-toggle-exclusive')) {
        currentlyOn = [];
      }

      currentlyOn.push(category);
    }
    else {
      // Remove the previously-selected toggle from the list.
      currentlyOn = currentlyOn.filter(e => e !== category);
    }

    // Update the toggles with the new information.
    for (let i = 0; i < allToggles.length; i++) {
      const currentCategory = allToggles[i].getAttribute('data-toggle');

      if (currentlyOn.indexOf(currentCategory) !== -1) {
        allToggles[i].setAttribute('data-toggled', true);
        allToggles[i].checked = true;
      }
      else {
        allToggles[i].removeAttribute('data-toggled');
        allToggles[i].checked = false;
      }
    }

    // Update the items with the new information.
    for (let i = 0; i < allItems.length; i++) {
      const currentCategories = allItems[i].getAttribute('data-toggle-item').split(' ');
      let isOn = false;

      // Supports multiple values separated by a space.
      for (let j = 0; j < currentCategories.length; j++) {
        if (currentlyOn.indexOf(currentCategories[j]) !== -1) {
          isOn = true;
        }
      }

      if (isOn || !currentlyOn.length) {
        allItems[i].classList.remove('js-hidden');
      }
      else {
        allItems[i].classList.add('js-hidden');
      }
    }
  }

  function init() {
    filters = document.querySelector('.js-filters');
    originalFilters = document.querySelector('.js-filters-categories');
    selectedFilters = document.querySelector('.js-filters-selected');

    if (filters && !filters.classList.contains('js-component-init')) {
      const openFiltersButton = filters.querySelector('.js-filters-open-button');
      const closeFiltersButton = filters.querySelector('.js-filters-close-button');
      const submitFiltersButton = filters.querySelector('.js-filters-submit-button');
      const resetFiltersButton = filters.querySelector('.js-filters-reset-button');
      const categoryButtons = filters.querySelectorAll('.js-filters-category-button');
      const itemInputs = filters.querySelectorAll('.js-filters-item-input');
      const angleButtons = filters.querySelectorAll('.js-filters-angle-button');
      const prescriptionControls = filters.querySelectorAll('.js-filters-prescription-control');
      const visibilityToggles = filters.querySelectorAll('[data-toggle]');

      if (openFiltersButton && closeFiltersButton) {
        openFiltersButton.addEventListener('click', openFiltersCategories);
        closeFiltersButton.addEventListener('click', closeFiltersCategories);
      }

      if (submitFiltersButton && resetFiltersButton) {
        submitFiltersButton.addEventListener('click', closeFiltersCategories);
        resetFiltersButton.addEventListener('click', resetFilters);
      }

      for (let i = 0; i < categoryButtons.length; i++) {
        categoryButtons[i].addEventListener('click', toggleCategoryVisibility);
      }

      for (let i = 0; i < itemInputs.length; i++) {
        itemInputs[i].addEventListener('change', toggleFilter);
        itemInputs[i].addEventListener('focusin', frameFocusIn);
        itemInputs[i].addEventListener('focusout', frameFocusOut);
        resetFilterIfUnselected(itemInputs[i]);
      }

      for (let i = 0; i < angleButtons.length; i++) {
        angleButtons[i].addEventListener('click', switchAngle);
      }

      for (let i = 0; i < prescriptionControls.length; i++) {
        prescriptionControls[i].addEventListener('click', togglePrescription);
      }

      for (let i = 0; i < visibilityToggles.length; i++) {
        visibilityToggles[i].addEventListener('click', toggleVisibility);
      }

      window.addEventListener('resize', handlePageResize);
      handleFilterCategoriesEventListener();

      // Add class to indicate component is instantiated.
      filters.classList.add('js-component-init');
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
